import * as NewMembersAction from './newMembers.actions';
import { NewMemberState, INIT_NEW_MEMBER_STATE } from './newMembers.state';
import { Action, createReducer, on } from '@ngrx/store';

const _newMembersReducer = createReducer(

    INIT_NEW_MEMBER_STATE,
    
    on(
        NewMembersAction.displayRequestsAction,
        (state, action) => {
            const stateCopy = { ...state };
            stateCopy[action.gameStateId] = 'requests';
            return stateCopy;
        }
    ),

    on(
        NewMembersAction.displayCounterAction,
        (state, action) => {
            const stateCopy = { ...state };
            stateCopy[action.gameStateId] = 'counter';
            return stateCopy;
        }
    ),

    on(
        NewMembersAction.displayInfoAction,
        (state, action) => {
            const stateCopy = { ...state };
            stateCopy[action.gameStateId] = 'info';
            return stateCopy;
        }
    ),

    on(
        NewMembersAction.removeActiveTab,
        (state, action) => {
            const stateCopy = { ...state };
            delete stateCopy[action.gameStateId];
            return stateCopy;
        }
    ),
)

export function newMembersReducer(state: NewMemberState, action: Action) {
    return _newMembersReducer(state, action);
}
